import React from 'react'
import { UploadCsv } from './uploadCsv'
import { DiscountType } from '../_shared'
import { ModalBody } from 'uiComponents/popups/modal.new'
import { OptionTile } from 'uiComponents/optionTile'

interface ChooseDiscountTypeProps {
    onSelectDiscountType: (discountType: DiscountType) => void
}

export const ChooseDiscountType = ({ onSelectDiscountType }: ChooseDiscountTypeProps) => (
    <ModalBody>
        <OptionTile
            title="Cart discount"
            description="Applies to all products in the cart"
            icon="ShoppingCart"
            onClick={() => onSelectDiscountType('cart')}
        />
        <OptionTile
            title="Product discount"
            description="Applies only to specific products in the cart"
            icon="Tag"
            onClick={() => onSelectDiscountType('product')}
        />
        <UploadCsv />
    </ModalBody>
)
